import { $, $$, aviso, destrabarEn, esc, fijarPermisos, fijarYo, limpiar, pedir, PERMISOS, puede, sb, YO } from './nucleo';
import { cargarCatalogos, cargarProductos, reintentarProductos, reintentarRecepcion } from './catalogo';
import { cargarStock } from './stock';
import { cargarCompras } from './compras';
import { cargarRecepcion } from './recepcion';
import { cargarConteo } from './conteo';
import { cargarRoles, cargarUsuarios } from './usuarios';
import { asegurarZonas, cargarClientes, cerrarFicha } from './clientes';
import { cargarCatalogosPedido, cargarCotizaciones, cargarPedidos, reintentarPedidos } from './pedidos';
import { cerrarVenta } from './venta';
import { cargarCuentas } from './cuentas';
import { cargarComisiones } from './comisiones';
import { catalogosCobro } from './cobros';
import { cargarCaja, cargarHabilitacion } from './caja';
import { cargarCircuito, cargarTransiciones, esperandoCircuito, reintentarTransiciones } from './circuito';
import { cargarUnidades } from './equipos';
import { cargarPrecios } from './precios';
import { cargarAprobaciones } from './aprobaciones';
import { cargarVueltas } from './vueltas';
import { cargarRendiciones } from './rendiciones';
import { ajustesPorLaPlata, cargarAjustes } from './ajustes';
import { cargarActividad } from './actividad';
import { cargarRentabilidad } from './rentabilidad';
import { cargarProveedores } from './proveedores';
import { cargarFotos } from './fotos';
import { cargarVacaciones } from './vacaciones';
import './menu';
import { activarCombos } from './combo';

//  Los desplegables marcados con `data-combo` pasan a escribirse (D216).
//  Después de los imports: cada módulo ya pintó y enganchó sus `<select>`.
activarCombos();

// ---------- sesión ----------
$('#btnGoogle').onclick = async () => {
  const { error } = await sb.auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo: window.location.href.split('#')[0] }
  });
  if (error) aviso('#loginMsg','bad', error.message);
};

$('#formMagic').onsubmit = async e => {
  e.preventDefault();
  const { error } = await sb.auth.signInWithOtp({
    email: $('#mail').value.trim(),
    options: { emailRedirectTo: window.location.href.split('#')[0] }
  });
  if (error) aviso('#loginMsg','bad', error.message);
  else aviso('#loginMsg','ok','Listo. Revisá tu correo y abrí el enlace.');
};

$('#btnSalir').onclick = async () => { await sb.auth.signOut(); location.reload(); };

function salir(){ $('#login').classList.remove('oculto'); $('#app').classList.add('oculto'); }

//  En producción `entrar()` corre más de una vez (`onAuthStateChange` con la
//  sesión inicial y en cada renovación de token, además de `getSession()`).
//  Una lectura que falla en la SEGUNDA vuelta no puede borrar lo ya leído ni
//  tapar la aplicación con el cartel de que no se ven las pestañas.
let ENTRO = false;

async function entrar(session){
  $('#login').classList.add('oculto');
  $('#app').classList.remove('oculto');

  //  Las dos lecturas de las que depende TODO. Si una no se pudo leer no
  //  alcanza con seguir: "tu cuenta no está dada de alta" sería falso, y sin
  //  permisos se entraría sin decir nada (D92). Van por `pedir()` y el cartel
  //  ofrece reintentar sin recargar.
  const { data: yo, error: eYo } =
    await pedir(sb.from('v_mi_usuario').select('*').maybeSingle());
  if (eYo && ENTRO) return;
  fijarYo(eYo ? null : yo);

  if (eYo){
    $('#quien').textContent = session.user.email;
    noSePudoEntrar(session, 'tu usuario', eYo.message,
      'No es que tu cuenta no esté dada de alta: es que no se pudo leer.');
    return;
  }

  if (!yo){
    $('#quien').textContent = session.user.email;
    $('#sinAlta').classList.remove('oculto');
    $('#sinAlta').innerHTML =
      `Tu cuenta <b>${esc(session.user.email)}</b> se autenticó correctamente, pero no está
       dada de alta como usuario del sistema, así que no ves ningún dato.
       <br><br>Es a propósito: el alta la hace un administrador. Autenticarse con Google
       no alcanza para entrar.`;
    return;
  }

  $('#quien').innerHTML =
    `<b>${esc(yo.nombre)}</b> · ${esc((yo.roles||[]).join(', ')) || 'sin rol'}`;
  const { data: perms, error: ePerms } = await pedir(sb.from('v_mis_permisos')
    .select('*').order('recurso').order('accion'));
  if (ePerms && ENTRO) return;
  if (ePerms){
    fijarPermisos([]);
    noSePudoEntrar(session, 'tus permisos', ePerms.message,
      'Por eso no ves las pestañas de tu trabajo: no es que no las tengas.');
    return;
  }
  //  El cartel se esconde también acá, no sólo en el botón de reintentar: la
  //  vuelta que anda puede ser la del `onAuthStateChange`.
  $('#sinAlta').classList.add('oculto');
  limpiar('#sinAlta');
  fijarPermisos(perms || []);
  ENTRO = true;


  //  Compras: la abre quien arma las órdenes y quien sólo las mira. Qué
  //  tarjeta se muestra adentro lo decide `cargarCompras`.
  if (puede('compra','ver') || puede('compra','crear')){
    $('#tabCompras').classList.remove('oculto');
    cargarCompras();
  }
  //  Recepción es una puerta como las demás: sin `recepcion.ver`/`crear` el
  //  vendedor vería el formulario y la base se lo rebotaría al enviar.
  if (puede('recepcion','ver') || puede('recepcion','crear')){
    $('#tabRecepcion').classList.remove('oculto');
    cargarRecepcion();
  }
  //  Ingresos por foto (0076): la abre `config.administrar` (admin / dueño),
  //  que es el mismo recorte que hace la base con app.es_admin().
  if (puede('config','administrar')){
    $('#tabFotos').classList.remove('oculto');
    cargarFotos();
  }
  if (puede('stock','ver')){
    $('#tabEquipos').classList.remove('oculto');
    cargarUnidades();
  }
  if (puede('pedido','ver')){
    $('#tabPedidos').classList.remove('oculto');
    //  Ver pedidos y CREARLOS son dos permisos (D102: abrir, leer y actuar son
    //  tres preguntas). `pedido.crear` con CUALQUIER alcance abre la tarjeta: el
    //  vendedor lo tiene en `propio` y crea los suyos.
    if (puede('pedido','crear')) $('#cardNuevoPedido').classList.remove('oculto');
    cargarCatalogosPedido();
    cargarClientes();
    cargarPedidos();
  }
  if (puede('item','cambiar_estado')){
    $('#tabCircuito').classList.remove('oculto');
    //  ENCADENADAS, no en paralelo: la tabla se pinta con la lista de pasos ya
    //  contestada; sueltas, la tabla podía ganar la carrera y dejar «nada para
    //  vos» en todas las filas.
    //
    //  ANTES DE PEDIR NADA la tabla dice que está leyendo: el botón de la
    //  pestaña ya está destapado y un cuerpo vacío se lee "no hay nada pendiente".
    //  UNA SOLA LLAMADA, acá y no también en el cambio de pestaña: `entrar()`
    //  corre antes que cualquier click, y una segunda llamada en el handler no
    //  se distinguiría de su ausencia (la regla «está DUPLICADA»).
    esperandoCircuito();
    cargarTransiciones().then(() => cargarCircuito());
  }
  if (puede('cliente','ver')){
    $('#tabClientes').classList.remove('oculto');
    cargarClientes();
  }
  //  La cuenta corriente la ve quien puede ver saldos (el vendedor, los suyos;
  //  el cajero, todos) y la administra quien tiene el permiso propio: dos
  //  preguntas (0033).
  if (puede('cliente','ver_saldo') || puede('cliente','limite_credito')){
    $('#tabCuentas').classList.remove('oculto');
    if (puede('cliente','limite_credito'))
      $('#cardCredito').classList.remove('oculto');
    cargarCuentas();
  }
  //  La pestaña de Comisiones la abre cualquiera de los cinco permisos. Qué
  //  tarjeta se muestra adentro lo decide `cargarComisiones`.
  if (puede('comision','ver') || puede('comision','configurar') ||
      puede('liquidacion','ver') || puede('liquidacion','generar') ||
      puede('liquidacion','pagar')){
    $('#tabComisiones').classList.remove('oculto');
    cargarComisiones();
  }
  if (puede('caja','ver') || puede('caja','operar')){
    $('#tabCaja').classList.remove('oculto');
    catalogosCobro().then(() => { cargarCaja(); cargarRendiciones(); });
  }
  if (puede('rendicion','recibir')) $('#cardRendiciones').classList.remove('oculto');
  if (puede('caja','asignar')){
    $('#cardHabilitacion').classList.remove('oculto');
    cargarHabilitacion();
  }
  //  El reparto: logística arma, el motoquero carga. El motoquero no tiene
  //  `pedido.ver` a propósito: lo que ve sale del RLS de su propia vuelta.
  if (puede('vuelta','ver') || puede('entrega','registrar')){
    $('#tabVueltas').classList.remove('oculto');
    cargarVueltas();
  }
  //  El conteo lo abre cualquiera de los permisos del punto 6 (el picker por
  //  `conteo.contar`, el supervisor por `desvio.ver`). Qué tarjeta se muestra
  //  adentro lo decide `cargarConteo`.
  if (puede('conteo','ver') || puede('conteo','contar') || puede('conteo','cerrar') ||
      puede('desvio','ver') || puede('stock','ajustar')){
    $('#tabConteo').classList.remove('oculto');
    cargarConteo();
  }
  //  Ajustes es del que configura el sistema y del que audita: dos permisos,
  //  cada uno ve su tarjeta.
  //
  //  Desde la 0071 (D164) el dueño y el admin global tienen `config.administrar`.
  //  Queda la otra puerta para un `costo.ver` sin configurar: se le pregunta a
  //  la base si es dueño o admin global (`ajustesPorLaPlata`, que explica por
  //  qué una lectura fallida abre igual).
  //
  //  Con `await` y no suelto: `entrar()` termina cuando las pestañas quedaron
  //  decididas, y las pruebas miran la barra después de eso.
  if (puede('config','administrar') || puede('auditoria','ver')){
    $('#tabAjustes').classList.remove('oculto');
    cargarAjustes();
  } else if (await ajustesPorLaPlata()){
    $('#tabAjustes').classList.remove('oculto');
    cargarAjustes(true);
  }
  //  La Actividad se lee al ABRIR la pestaña, no al entrar: son cuatro
  //  lecturas sobre las tablas más grandes.
  if (puede('auditoria','ver')) $('#tabActividad').classList.remove('oculto');
  //  La Rentabilidad, igual: se calcula al ABRIRLA. La abre `costo.ver` (rol
  //  `dueno`; el admin global sólo con la casilla de Ajustes, D164). Es la pregunta
  //  de la base: `rentabilidad()` tira 42501 sin ese permiso.
  if (puede('costo','ver')) $('#tabRentabilidad').classList.remove('oculto');
  //  La cuenta de los proveedores, igual. La abre `proveedor.ver_cuenta`
  //  (D114); sin él `v_proveedores_cc` contesta lista vacía sin error, así que
  //  la pestaña ni se muestra.
  if (puede('proveedor','ver_cuenta')) $('#tabProveedores').classList.remove('oculto');
  if (puede('cotizacion','cargar')){
    $('#cardCotiz').classList.remove('oculto');
    cargarCotizaciones();
  }

  if (puede('precio','editar')){
    $('#tabPrecios').classList.remove('oculto');
    cargarPrecios();
  }

  if (puede('usuario','gestionar')){
    $('#tabUsuarios').classList.remove('oculto');
    cargarRoles();
    cargarUsuarios();
  }

  if (puede('aprobacion','resolver')){
    $('#cardResolver').classList.remove('oculto');
    $('#cardHistorialAp').classList.remove('oculto');
  }
  cargarAprobaciones();
  //  Vacaciones (0104, D224): la pestaña la ve cualquiera (lo suyo); lo de
  //  configurar, quien tiene `vacaciones.configurar`.
  cargarVacaciones();

  cargarAcceso();
  cargarCatalogos();
  cargarStock();
  cargarProductos();
}

//  El cartel de las dos lecturas de arranque. Vive en `#sinAlta`, lo único que
//  se ve antes de que haya pestañas; el botón vuelve a correr `entrar()` entero.
function noSePudoEntrar(session, que: string, mensaje: string, aclaracion: string){
  $('#sinAlta').classList.remove('oculto');
  $('#sinAlta').innerHTML =
    `No se pudo leer ${esc(que)} (${esc(mensaje)}). <b>${esc(aclaracion)}</b>
     <br><br><button class="b b-pri" type="button" id="btnReentrar">Reintentar</button>`;
  //  El botón no esconde el cartel: lo esconde `entrar()` cuando anda.
  $('#btnReentrar').onclick = () => entrar(session);
}

// ---------- pestañas ----------
$$('#tabs button').forEach(b => b.onclick = () => {
  $$('#tabs button').forEach(x => x.setAttribute('aria-selected', String(x === b)));
  $$('main section').forEach(s => s.classList.add('oculto'));
  $('#s-' + b.dataset.t).classList.remove('oculto');
  //  Antes que cualquier `cargar…`: los botones apagados porque la base no
  //  contestó vuelven acá (D91, D92).
  destrabarEn('#s-' + b.dataset.t);
  if (b.dataset.t === 'compras')  cargarCompras();
  //  Reintentar lo que no se pudo leer al entrar (los catálogos se leen una
  //  sola vez en `entrar()`). Si no falló nada, no consulta nada.
  if (b.dataset.t === 'recepcion'){ reintentarRecepcion(); cargarRecepcion(); }
  if (b.dataset.t === 'productos') reintentarProductos();
  if (b.dataset.t === 'fotos')    cargarFotos();
  if (b.dataset.t === 'stock')    cargarStock();
  if (b.dataset.t === 'conteo')   cargarConteo();
  if (b.dataset.t === 'usuarios') cargarUsuarios();
  if (b.dataset.t === 'equipos')  cargarUnidades();
  //  Y lo mismo en Pedidos y en Clientes, cada uno con lo suyo (regla 11: el
  //  reintento también es por destino).
  if (b.dataset.t === 'pedidos'){
    //  Se llega a la lista, no a la última venta que quedó abierta (D220).
    cerrarVenta();
    reintentarPedidos(); cargarProductos(); cargarClientes(); cargarPedidos();
  }
  //  El circuito: primero las transiciones (dibujan los botones de cada fila),
  //  después la lista; al revés, la tabla se pintaría con la lista vieja.
  if (b.dataset.t === 'circuito') reintentarTransiciones().then(() => cargarCircuito());
  //  Las tres de la pestaña Caja, y la de habilitación: es su único reintento
  //  (sus botones se pintan dentro del map de la lista, y si la lectura falla
  //  al arrancar no queda botón que la recargue).
  if (b.dataset.t === 'caja'){
    cargarCaja(); cargarRendiciones();
    if (puede('caja','asignar')) cargarHabilitacion();
  }
  if (b.dataset.t === 'vueltas')  cargarVueltas();
  //  Las zonas llenan el select del alta de cliente: las lee quien abre ESTA
  //  pestaña, no `entrar()` con `pedido.ver`. Una sola vez: `asegurarZonas` no
  //  consulta si ya salieron bien.
  if (b.dataset.t === 'clientes'){ cerrarFicha(); asegurarZonas(); cargarClientes(); }
  if (b.dataset.t === 'cuentas')  cargarCuentas();
  if (b.dataset.t === 'precios')  cargarPrecios();
  if (b.dataset.t === 'comisiones') cargarComisiones();
  if (b.dataset.t === 'aprobaciones') cargarAprobaciones();
  if (b.dataset.t === 'ajustes')  cargarAjustes();
  if (b.dataset.t === 'actividad') cargarActividad();
  if (b.dataset.t === 'rentabilidad') cargarRentabilidad();
  if (b.dataset.t === 'proveedores') cargarProveedores();
  if (b.dataset.t === 'vacaciones') cargarVacaciones();
});

$('#btnAvisos').onclick = () => {
  const b = $('#tabs button[data-t="aprobaciones"]');
  if (b) b.click();
};

// ---------- mi acceso ----------
async function cargarAcceso(){
  $('#miUsuario').innerHTML = `
    <div class="grid g3">
      <div><div class="hint">Nombre</div><b>${esc(YO.nombre)}</b></div>
      <div><div class="hint">Email</div><span class="mono">${esc(YO.email)}</span></div>
      <div><div class="hint">Roles</div>${
        (YO.roles||[]).map(r=>`<span class="chip c-pen">${esc(r)}</span>`).join(' ') || '—'}</div>
    </div>`;

  $('#tblPermisos').innerHTML = PERMISOS.map(p => `
    <tr><td class="mono">${esc(p.recurso)}</td><td class="mono">${esc(p.accion)}</td>
        <td><span class="chip ${p.alcance==='propio'?'c-warn':'c-ok'}">${esc(p.alcance)}</span></td></tr>
  `).join('') || '<tr><td colspan="3" class="vacio">Sin permisos asignados</td></tr>';
}

sb.auth.onAuthStateChange((_e, session) => session ? entrar(session) : salir());
sb.auth.getSession().then(({data}) => { if (data.session) entrar(data.session); });
